import { api } from './client'

export type AppNotificationType = 'success' | 'error' | 'warning' | 'info'

export interface AppNotification {
  id:              string
  orgId:           string
  recipientUserId: string
  type:            AppNotificationType
  title:           string
  message?:        string
  resourceType?:   string
  resourceId?:     string
  link?:           string
  metadata?:       Record<string, unknown>
  readAt?:         string
  createdAt:       string
}

export interface NotificationListResponse {
  data:   AppNotification[]
  total:  number
  unread: number
  limit:  number
  offset: number
}

export interface CreateNotificationPayload {
  recipientUserId?:  string
  recipientUserIds?: string[]
  type?:             AppNotificationType
  title:             string
  message?:          string
  resourceType?:     string
  resourceId?:       string
  link?:             string
  metadata?:         Record<string, unknown>
}

const BASE = '/api/v1/notifications'

export const notificationsApi = {
  list: (params: { limit?: number; offset?: number; unreadOnly?: boolean } = {}) => {
    const qs = new URLSearchParams()
    if (params.limit) qs.set('limit', String(params.limit))
    if (params.offset) qs.set('offset', String(params.offset))
    if (params.unreadOnly) qs.set('unreadOnly', 'true')
    const query = qs.toString()
    return api.get<NotificationListResponse>(`${BASE}${query ? `?${query}` : ''}`)
  },

  create: (payload: CreateNotificationPayload) =>
    api.post<{ data: AppNotification[] }>(BASE, payload),

  markRead: (id: string) =>
    api.put<void>(`${BASE}/${id}/read`),

  markAllRead: () =>
    api.put<void>(`${BASE}/read-all`),
}
